import React, { useEffect, useState, Children } from 'react';
import classnames from 'classnames';

// utils
import { isElementOfType, sanitizeFragments } from '../../utilities/components';

//Components
import WpStep from './WpStep';

// Styles
import './WpSteps.scss';

export type DirectionType = 'vertical' | 'horizontal';
const DEFAULT_DIRECTION_TYPE = 'horizontal';

export interface Props {
  children?: React.ReactNode;
  direction?: DirectionType;
  activeStepNumber?: number;
}

const WpSteps: React.FC<Props> = ({ children, direction = DEFAULT_DIRECTION_TYPE, activeStepNumber }: Props) => {
  const [activeId, setActiveId] = useState(activeStepNumber || 1);

  useEffect(() => {
    if (activeStepNumber) setActiveId(activeStepNumber);
  }, [activeStepNumber]);

  const sanitizedChildren = children && sanitizeFragments(children);
  const childrenSteps = Children.toArray(sanitizedChildren).filter(child =>
    isElementOfType(child, [WpStep])
  ) as React.ReactElement[];

  const stepContent = childrenSteps.map((child, index) => {
    const stepNumber = index + 1;
    const newProps = {
      stepNumber,
      active: child.props.active || activeId === stepNumber,
      completed: child.props.completed || stepNumber < activeId,
      direction,
    };
    return React.cloneElement(child, newProps);
  });
  const classNamePrefix = 'WpSteps-v2';
  const classes = classnames(classNamePrefix, `${classNamePrefix}--${direction}`);
  return <div className={classes}>{stepContent}</div>;
};

export default WpSteps;
